import { Icon, Typography, Space } from '@sravni/react-design-system';
import { Copy } from '@sravni/react-icons';

import styles from './styles.module.scss';

const { Text } = Typography;

export const CopiedNotification = () => {
    const a = 1;

    return (
        <Space className={styles.root} size={12}>
            <Icon icon={<Copy />} size={24} />
            <Text className="h-color-L100">Промокод скопирован</Text>
        </Space>
    );
};
